import * as React from 'react'
import { CalendarIcon } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Calendar } from '@/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { cn } from '@/lib/utils'

interface CalendarFieldProps {
  label: string
  selected: Date | undefined
  // The raw day react-day-picker yields is timezone-naive (local midnight); the
  // caller owns interpreting/normalizing it, so both `formatLabel` and `onSelect`
  // receive Dates the caller can read in whatever calendar it speaks.
  formatLabel: (date: Date) => string
  isDisabled: (day: Date) => boolean
  onSelect: (day: Date) => void
  placeholder?: string
}

function CalendarField({ label, selected, formatLabel, isDisabled, onSelect, placeholder }: CalendarFieldProps) {
  const [open, setOpen] = React.useState(false)
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-muted-foreground text-xs font-medium">{label}</label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            className={cn('w-full justify-between font-normal', !selected && 'text-muted-foreground')}
          >
            <span>{selected ? formatLabel(selected) : placeholder}</span>
            <CalendarIcon className="size-4 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={selected}
            disabled={isDisabled}
            onSelect={(day) => {
              if (day) {
                onSelect(day)
                setOpen(false)
              }
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}

export { CalendarField }
